import md5 from 'js-md5';

const generateKey = (...args) => md5(JSON.stringify(args));

export default generateKey;
